import { render, staticRenderFns } from "./preference-update.vue?vue&type=template&id=a71d6a4c&scoped=true"
import script from "./preference-update.vue?vue&type=script&lang=js"
export * from "./preference-update.vue?vue&type=script&lang=js"
import style0 from "./preference-update.vue?vue&type=style&index=0&id=a71d6a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d6a4c",
  null
  
)

export default component.exports